/** Shared browser/Edge issued-code privacy shape: all 50 states plus DC. */
export const ISSUED_CODE_STATE_PREFIXES = [
  "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FL", "GA",
  "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD", "MA",
  "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY",
  "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX",
  "UT", "VT", "VA", "WA", "WV", "WI", "WY",
] as const;

const NATIONAL_CODE_SOURCE = String.raw`(?:${ISSUED_CODE_STATE_PREFIXES.join("|")})-[A-Z]{2,4}(?:[:-]\s*[A-Z0-9]+)+`;
const LEGACY_CODE_SOURCE = String.raw`(?:HX[A-Z0-9]{4,5}|H[A-Z]\d{4,6}[A-Z]?)`;

// Pattern sources avoid sharing mutable RegExp.lastIndex between consumers.
// Non-state strings such as EU-SALE-2026 remain ordinary coarse context.
export const ISSUED_PROPERTY_CODE_SOURCE = String.raw`(?:${NATIONAL_CODE_SOURCE}|${LEGACY_CODE_SOURCE})`;
